import axios from 'axios';

export default {
    async createJobOrder(dataParams) {
        return axios.post('api/joborders', dataParams);
    },
    async getOrders(urlParams) {
        return axios.get('api/orders', { params: urlParams });
    },
    async getOrder(orderId) {
        return axios.get(`api/orders/${orderId}`);
    },
    async updateOrder(orderId, dataParams) {
        return axios.put(`api/orders/${orderId}`, dataParams);
    },
    async updateOrderStatus(orderId, status) {
        const dataParams = { status: status };
        return axios.post(`api/orders/${orderId}/status`, dataParams);
    },
    async updateOrderCourier(orderId, courierinfoId) {
        const dataParams = { courierinfo_id: courierinfoId };
        return axios.post(`api/orders/${orderId}/courierinfo`, dataParams);
    },
    async deleteOrder(orderId) {
        return axios.delete(`api/orders/${orderId}`);
    }
};
